import { Button, CircularProgress, DialogActions, Dialog, DialogTitle, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, DialogContent } from "@mui/material";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import * as React from "react";
import { useContext, useState, useEffect } from "react";
import { DataUser } from "../../context/DataUser";
import { DataPM } from "../../context/DataPM";
import { uploadAudioForSegments } from "../../utils/audio/generateMix";
import { getSegmentsProject } from "../../utils/regions/getRegions";

const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.round(seconds % 60);

  let timeStr = '';
  if (hrs > 0) {
    timeStr += `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  } else if (mins > 0) {
    timeStr += `${mins}:${secs.toString().padStart(2, '0')}`;
  } else {
    timeStr += secs.toString().padStart(2, '0');
  }
  
  return timeStr;
};

const Modaladdcreditsproject = ({ open, setOpen, projectId }) => {
  const [loading, setLoading] = useState(false);
  const [descriptions, setDescriptions] = useState([]);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [segmentIds, setSegmentIds] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [audioFile, setAudioFile] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const { user } = useContext(DataUser);

  useEffect(() => {
    if (open && projectId) {
      fetchSegments();
    } else {
      // Limpiar los estados cuando se cierra el modal
      setDescriptions([]);
      setSelectedDescription("");
      setSegmentIds([]);
      setAudioFile(null);
    }
  }, [open, projectId]);

  const fetchSegments = async () => {
    try {
      setLoading(true);
      const response = await getSegmentsProject(projectId);
      //console.log("response", response);
      if (response && Array.isArray(response)) {
        // Ordenar los segmentos por tiempo de inicio, asegurando conversión numérica
        const sortedSegments = response
          .filter(segment => segment && segment.description)
          .sort((a, b) => {
            const startA = parseFloat(a.start);
            const startB = parseFloat(b.start);
            return startA - startB;
          });
        //console.log("Segmentos ordenados por tiempo:", sortedSegments.map(s => ({
          //tiempo: parseFloat(s.start),
          //descripcion: s.description.initial
        //})));
        setDescriptions(sortedSegments);
      }
    } catch (error) {
      //console.error("Error fetching segments:", error);
      setToastMessage("Error fetching segments");
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleDescriptionSelect = async (segmentId) => {
    setSelectedDescription(segmentId);
    const selectedSegment = descriptions.find(seg => seg._id === segmentId);
    if (selectedSegment) {
      setSegmentIds([selectedSegment._id]);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setDescriptions([]);
    setSelectedDescription("");
    setSegmentIds([]);
    setAudioFile(null);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "audio/wav") {
      setAudioFile(file);
      setToastMessage("Audio file selected successfully");
      setToastSeverity("success");
      setOpenToast(true);
    } else {
      setToastMessage("Please select a valid WAV file");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };

  const handleConfirmUpload = async () => {
    try {
      setLoading(true);
      const result = await uploadAudioForSegments(audioFile, segmentIds, projectId);
      
      if (result.error) {
        setToastMessage(result.error);
        setToastSeverity("error");
      } else {
        setToastMessage(result.msg || "Audio uploaded successfully");
        setToastSeverity("success");
        setOpenConfirmModal(false);
        handleClose();
      }
    } catch (error) {
      //console.error("Error uploading audio:", error);
      setToastMessage("Error uploading audio");
      setToastSeverity("error");
    } finally {
      setLoading(false);
      setOpenToast(true);
    }
  };

  return (
    <>
      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={() => setOpenToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={toastSeverity}>{toastMessage}</Alert>
      </Snackbar>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#28262E",
            color: "white"
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "white", backgroundColor: "#28262E" }}
        >
          Add Credits to Project
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#28262E", padding: 3 }}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
              <CircularProgress />
            </div>
          ) : (
            <div>
              <FormControl fullWidth variant="outlined" sx={{ marginBottom: "20px" }}>
                <InputLabel id="description-select-label" sx={{ color: 'white' }}>Select Description</InputLabel>
                <Select
                  labelId="description-select-label"
                  id="description-select"
                  value={selectedDescription}
                  onChange={(e) => handleDescriptionSelect(e.target.value)}
                  label="Select Description"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        backgroundColor: '#28262E',
                        color: 'white',
                        maxHeight: 400,
                        '& .MuiMenuItem-root': {
                          borderBottom: '1px solid rgba(255,255,255,0.1)',
                          '&:last-child': {
                            borderBottom: 'none'
                          }
                        }
                      }
                    }
                  }}
                  sx={{
                    color: 'white',
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: 'white',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'white',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'white',
                    },
                    '.MuiSvgIcon-root': {
                      color: 'white',
                    }
                  }}
                >
                  {descriptions && descriptions.length > 0 ? (
                    descriptions.map((segment, index) => (
                      <MenuItem 
                        key={segment._id} 
                        value={segment._id}
                        sx={{
                          '&:hover': {
                            backgroundColor: '#3f3f3f'
                          },
                          '&.Mui-selected': {
                            backgroundColor: '#4a4a4a'
                          },
                          padding: '12px 16px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          gap: '4px'
                        }}
                      >
                        <div style={{ 
                          display: 'flex', 
                          flexDirection: 'column', 
                          width: '100%',
                          gap: '8px'
                        }}>
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            width: '100%',
                            alignItems: 'center'
                          }}>
                            <span style={{ 
                              fontWeight: 'bold',
                              fontSize: '1.1em',
                              color: '#8EC36A'
                            }}>
                              Segment {index + 1}
                            </span>
                            <span style={{ 
                              fontSize: '0.9em',
                              color: '#aaa',
                              backgroundColor: 'rgba(255,255,255,0.1)',
                              padding: '2px 8px',
                              borderRadius: '4px'
                            }}>
                              {formatTime(parseFloat(segment.start))} - {formatTime(parseFloat(segment.end))}
                            </span>
                          </div>
                          <div style={{ 
                            fontSize: '1em',
                            color: 'white',
                            lineHeight: '1.4'
                          }}>
                            {segment.description.initial}
                          </div>
                          {segment.audiorecord?.initial && (
                            <div style={{ 
                              fontSize: '0.85em',
                              color: '#8EC36A',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px'
                            }}>
                              <span style={{ fontSize: '1.2em' }}>•</span> Has audio
                            </div>
                          )}
                        </div>
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No segments available</MenuItem>
                  )}
                </Select>
              </FormControl>

              {selectedDescription && (
                <div style={{ marginTop: "20px" }}>
                  <h3>Upload WAV Audio</h3>
                  <input
                    accept="audio/wav"
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="raised-button-file">
                    <Button
                      variant="contained"
                      component="span"
                      startIcon={<CloudUploadIcon />}
                      sx={{
                        backgroundColor: '#8EC36A',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: '#7ab358'
                        }
                      }}
                    >
                      Select WAV File
                    </Button>
                  </label>
                  {audioFile && (
                    <div style={{ marginTop: '10px', color: 'white' }}>
                      Selected file: {audioFile.name}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: "#28262E",
            padding: 3,
            display: "flex",
            justifyContent: "flex-end",
            gap: 2
          }}
        >
          <Button
            onClick={handleClose}
            sx={{ color: "white", backgroundColor: "#952937" }}
          >
            Cancel
          </Button>
          {selectedDescription && audioFile && (
            <Button
              onClick={() => setOpenConfirmModal(true)}
              sx={{ 
                color: "white", 
                backgroundColor: "#8EC36A",
                '&:hover': {
                  backgroundColor: '#7ab358'
                }
              }}
              startIcon={<CloudUploadIcon />}
              disabled={loading}
            >
              Upload
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        aria-labelledby="confirm-dialog-title"
        PaperProps={{
          sx: {
            backgroundColor: "#28262E",
            color: "white"
          }
        }}
      >
        <DialogTitle id="confirm-dialog-title" sx={{ color: "white" }}>
          Confirm Audio Upload
        </DialogTitle>
        <DialogContent sx={{ color: "white", pt: 2 }}>
          <div style={{ marginBottom: '15px' }}>
            This audio will be applied to the selected segment. Are you sure you want to proceed?
          </div>
          <div style={{ 
            backgroundColor: 'rgba(255,255,255,0.1)', 
            padding: '10px', 
            borderRadius: '4px',
            fontSize: '0.9em' 
          }}>
            <div style={{ marginBottom: '8px' }}>
              <strong>File:</strong> {audioFile?.name}
            </div>
            <div>
              <strong>Selected segment:</strong> {selectedDescription}
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#28262E", padding: 2 }}>
          <Button
            onClick={() => setOpenConfirmModal(false)}
            sx={{ color: "white", backgroundColor: "#952937" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmUpload}
            sx={{ 
              color: "white", 
              backgroundColor: "#8EC36A",
              '&:hover': {
                backgroundColor: '#7ab358'
              }
            }}
            disabled={loading}
          >
            Confirm Upload
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Modaladdcreditsproject;